export default "__VITE_ASSET__DuC0FXCY__"